import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/h5/Home.vue'),
    },
    {
        path: '/market',
        name: 'Market',
        component: () => import('@/views/h5/Market.vue'),
    },
    {
        path: '/kline',
        name: 'Kline',
        component: () => import('@/views/h5/KLine.vue'),
    },
    {
        path: '/assets',
        name: 'Assets',
        component: () => import('@/views/h5/Assets.vue'),
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/h5/user/Login.vue'),
    }, {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/h5/user/Register.vue'),
    }, {
        path: '/forget',
        name: 'Forget',
        component: () => import('@/views/h5/user/Forget.vue'),
    },
    {
        path: '/flash',
        name: 'Flash',
        component: () => import('@/views/h5/flash/Flash.vue'),
    }, {
        path: '/flash/records',
        name: 'FlashRecords',
        component: () => import('@/views/h5/flash/Records.vue'),
    },
    {
        path: '/account/details',
        name: 'AccountDetails',
        component: () => import('@/views/h5/wallet/AssetsDetails.vue'),
    }, {
        path: '/account/coin',
        name: 'AccountCoin',
        component: () => import('@/views/h5/wallet/CoinDetails.vue'),
    },
    {
        path: '/transfer',
        name: 'Transfer',
        component: () => import('@/views/h5/transfer/Index.vue'),
    }, {
        path: '/transfer/records',
        name: 'TransferRecords',
        component: () => import('@/views/h5/flash/Records.vue'),
    }, {
        path: '/coin/records',
        name: 'CoinRecords',
        component: () => import('@/views/h5/flash/Records.vue'),
    }, {
        path: '/delivery',
        name: 'Delivery',
        component: () => import('@/views/h5/delivery/Index.vue'),
    },
    {
        path: '/contract',
        name: 'Contract',
        component: () => import('@/views/h5/contract/Index.vue'),
    }, {
        path: '/deposit',
        name: 'Deposit',
        component: () => import('@/views/h5/dw/Index.vue'),
    }, {
        path: '/deposit/details',
        name: 'DepositDetails',
        component: () => import('@/views/h5/dw/Deposit.vue'),
    }, {
        path: '/dw/records',
        name: 'DepositRecords',
        component: () => import('@/views/h5/dw/Records.vue'),
    }, {
        path: '/withdraw',
        name: 'Withdraw',
        component: () => import('@/views/h5/dw/Index.vue'),
    }, {
        path: '/withdraw/details',
        name: 'Withdraw',
        component: () => import('@/views/h5/dw/Withdraw.vue'),
    },
    {
        path: '/withdraw/address',
        name: 'WithdrawAddress',
        component: () => import('@/views/h5/dw/AddAddress.vue'),
    }, {
        path: '/support',
        name: 'Support',
        component: () => import('@/views/h5/notice/Index.vue'),
    },
    {
        path: '/support/details',
        name: 'SupportDetails',
        component: () => import('@/views/h5/notice/NoticeDetails.vue'),
    }, {
        path: '/notice',
        name: 'Notice',
        component: () => import('@/views/h5/notice/Index.vue'),
    },
    {
        path: '/notice/details',
        name: 'NoticeDetails',
        component: () => import('@/views/h5/notice/NoticeDetails.vue'),
    }, {
        path: '/about',
        name: 'About',
        component: () => import('@/views/h5/notice/NoticeDetails.vue'),
    }, {
        path: '/agreement',
        name: 'Agreement',
        component: () => import('@/views/h5/notice/NoticeDetails.vue'),
    }, {
        path: '/invest',
        name: 'Invest',
        component: () => import('@/views/h5/invest/Index.vue'),
    }, {
        path: '/invest/list',
        name: 'InvestList',
        component: () => import('@/views/h5/invest/InvestList.vue'),
    }, {
        path: '/user',
        name: 'User',
        component: () => import('@/views/h5/personal/Index.vue'),
    }, {
        path: '/help',
        name: 'Help',
        component: () => import('@/views/h5/help/Index.vue'),
    }, {
        path: '/userinfo',
        name: 'UserInfo',
        component: () => import('@/views/h5/personal/UserInfo.vue'),
    },
    {
        path: '/security',
        name: 'Security',
        component: () => import('@/views/h5/personal/UserInfo.vue'),
    },
    {
        path: '/share',
        name: 'Share',
        component: () => import('@/views/h5/personal/Share.vue'),
    }, {
        path: '/share/guide',
        name: 'ShareGuide',
        component: () => import('@/views/h5/personal/Guide.vue'),
    }, {
        path: '/follow/records',
        name: 'FollowRecords',
        component: () => import('@/views/h5/delivery/FollowRecords.vue'),
    },
    {
        path: "/download",
        name: "Download",
        component: () => import('@/views/h5/download/Index.vue')
    }, {
        path: "/download/des",
        name: "DownloadDes",
        component: () => import('@/views/h5/download/Description.vue')
    }, {
        path: "/safari/guide",
        name: "SafariGuide",
        component: () => import('@/views/h5/download/SafariGuide.vue')
    },{
        path: '/share/rules',
        name: 'ShareRules',
        component: () => import('@/views/h5/personal/Rules.vue'),
    },
    {
        path: '/finance',
        name: 'finance',
        component: () => import('@/views/h5/finance/index.vue'),
    },

]

const router = new VueRouter({
    mode: 'hash',
    base: "/h5/",
    routes,
})

export default router;